import { createFileRoute } from '@tanstack/react-router'
import { RefineTool } from '~/features/ai-studio/components'

export const Route = createFileRoute('/dashboard/ai-studio/refine')({
  component: RefineTool,
})
